"use client";

import {
  usePricingTableBase
} from "./chunk-PSE3LKMR.mjs";
import {
  useAutumnContext
} from "./chunk-EOSHPHLH.mjs";

// src/libraries/react/hooks/useAutumnBase.tsx
var useAutumnBase = ({
  AutumnContext
}) => {
  const context = useAutumnContext({ AutumnContext, name: "useAutumn" });
  const { prodChangeDialog, paywallDialog } = context;
  const client = context.client;
  const { refetch: refetchPricingTable } = usePricingTableBase({
    AutumnContext
  });
  let {
    setProps: setProdChangeDialogProps,
    setOpen: setProdChangeDialogOpen,
    setComponent: setProdChangeComponent
  } = prodChangeDialog;
  let {
    setProps: setPaywallDialogProps,
    setOpen: setPaywallDialogOpen,
    setComponent: setPaywallComponent
  } = paywallDialog;
  const attachWithDialog = async (params) => {
    let { dialog, ...rest } = params;
    const { productId, entityId, entityData } = params;
    const checkRes = await client.check({
      productId,
      entityId,
      entityData,
      withPreview: true
    });
    if (checkRes.error) {
      return checkRes;
    }
    let preview = checkRes.data.preview;
    if (!preview) {
      return await attach(rest);
    } else {
      setProdChangeDialogProps({
        preview
      });
      setProdChangeDialogOpen(true);
    }
    return checkRes;
  };
  const attach = async (params) => {
    const { dialog, openInNewTab } = params;
    if (dialog) {
      setProdChangeComponent(dialog);
      return await attachWithDialog(params);
    }
    const result = await client.attach(params);
    if (result.error) {
      return result;
    }
    let data = result.data;
    if (data?.checkout_url && typeof window !== "undefined") {
      if (openInNewTab) {
        window.open(data.checkout_url, "_blank");
      } else {
        window.location.href = data.checkout_url;
      }
    }
    await refetchPricingTable();
    if (setProdChangeDialogOpen) {
      setProdChangeDialogOpen(false);
    }
    return result;
  };
  const cancel = async (params) => {
    const res = await client.cancel(params);
    if (res.error) {
      return res;
    }
    return res;
  };
  const check = async (params) => {
    let { dialog, withPreview } = params;
    if (dialog) {
      setPaywallComponent(dialog);
    }
    const res = await client.check({
      ...params,
      withPreview: withPreview || dialog ? true : false
    });
    if (res.error) {
      return res;
    }
    let data = res.data;
    if (data && data.preview && dialog) {
      let preview = data.preview;
      setPaywallDialogProps({ preview });
      setPaywallDialogOpen(true);
    }
    return res;
  };
  const track = async (params) => {
    const res = await client.track(params);
    if (res.error) {
      return res;
    }
    return res;
  };
  const openBillingPortal = async (params) => {
    let defaultParams = {
      openInNewTab: false
    };
    let finalParams = {
      ...defaultParams,
      ...params
    };
    const res = await client.openBillingPortal(finalParams);
    if (res.error) {
      return res;
    }
    let data = res.data;
    if (data?.url && typeof window !== "undefined") {
      if (finalParams.openInNewTab) {
        window.open(data.url, "_blank");
      } else {
        window.open(data.url, "_self");
      }
      return res;
    } else {
      return res;
    }
  };
  return {
    attach,
    check,
    track,
    cancel,
    openBillingPortal
  };
};

export {
  useAutumnBase
};
